import React, { useMemo, useRef } from "react";
import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import { mediaQueryPoint, useMediaQuery } from "../../../../utils/hooks";
import { dataListProduct } from "./DefineData";

export default function ListProduct({
  itemProductActive,
  setItemProductActive,
}) {
  const dataSort = dataListProduct.sort((a, b) => b.id - a.id);

  const swiperRef = useRef(null);
  const postionItemMenuActive = useMemo(() => {
    let postionItemActive = 0;

    dataListProduct.forEach((item, index) => {
      if (item.id === itemProductActive) {
        postionItemActive = index;
      }
    });

    return postionItemActive;
  }, [itemProductActive]);

  const isMobileXs = useMediaQuery(`(max-width: ${mediaQueryPoint.xs}px)`);
  const isMobileSm = useMediaQuery(`(max-width: ${mediaQueryPoint.sm}px)`);

  return (
    <>
      <Container>
        <Swiper
          ref={swiperRef}
          slidesPerView={isMobileXs ? 2.5 : isMobileSm ? 3.5 : 4.7} // Hiển thị total slide mỗi lần
          spaceBetween={6} // Khoảng cách giữa các slide
          speed={500} // Tốc độ chuyển slide
          freeMode={true} // Cho phép trượt tự do theo lực vuốt
          freeModeMomentum={true} // Đà vuốt, giúp cảm giác mượt mà
          pagination={{ clickable: false }} // Chấm điều hướng
          //   onSlideChange={handleSlideChange}
          initialSlide={postionItemMenuActive}
        >
          {dataSort.map((item) => {
            return (
              <SwiperSlide
                key={item.id}
                onClick={() => setItemProductActive(item.id)}
                className={`prize-container ${
                  itemProductActive === item.id ? "prize-container-active" : ""
                }`}
              >
                <img
                  src={item.srcImg}
                  alt={item.title}
                  className={`icon-prize ${item.title ? "" : "prize-mmk"}`}
                />
                <div className="title-prize">{item.title}</div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </Container>
    </>
  );
}

const Container = styled.div`
  padding-left: 18px;
  margin-bottom: 20px;

  .icon-prize {
    position: absolute;
    top: 10px;
    height: 100px;
    z-index: 2;
    left: 50%;
    transform: translateX(-50%);
    padding: 0 5px;
  }

  .prize-container {
    position: relative;
    z-index: 1;
    height: 140px;
    cursor: pointer;
    border-radius: 8px;
    background: linear-gradient(
      to bottom,
      rgba(0, 60, 147, 0.6) 0%,
      rgba(5, 130, 198, 0.6) 100%
    );
  }

  .prize-mmk {
    height: auto;
    /* min-width: 150px; */
    max-width: 90%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .title-prize {
    position: absolute;
    bottom: 15px;
    z-index: 3;
    font-size: 12px;
    color: #ffebbd;
    left: 50%;
    transform: translateX(-50%);
    width: 90%;
    text-align: center;
    bottom: 8px;
    font-weight: bold;
    font-style: italic;
    filter: drop-shadow(1px 0 0 #f27a25) drop-shadow(-1px 0 0 #f27a25)
      drop-shadow(0 1px 0 #f27a25) drop-shadow(0 -1px 0 #f27a25) !important;
  }

  .prize-container-active {
    background: linear-gradient(to bottom, #227ffd 0%, #4ed7f7 100%);
    /* border: 2px solid white; */
    box-shadow: 0px 0px 6px 0px rgba(255, 255, 255, 1);
  }

  .prize-container-active:hover {
    background: linear-gradient(to bottom, #227ffd 0%, #4ed7f7 100%) !important;
    /* border: 2px solid white; */
    box-shadow: 0px 0px 6px 0px rgba(255, 255, 255, 1) !important;
  }

  @media (min-width: 992px) {
    .prize-container:hover {
      background: linear-gradient(
        to bottom,
        rgba(68, 120, 197, 0.6) 0%,
        rgba(50, 104, 185, 0.6) 100%
      );
      transition: 0.3s ease-in-out;
    }
  }

  @media (max-width: 576px) {
    padding-left: 12px;

    .icon-prize {
      height: 60px;
    }

    .prize-container{
      height: 105px;
    }
  }

  @media (min-width: 1400px) {
    padding-left: 40px;
  }
`;
